import Phone from "@husky-hrc/Components/Icons/Phone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    phoneNumber = "phoneNumber",
}

interface Props extends WidgetProps {
    fields: {
        [fields.phoneNumber]: string;
    };
}

export interface ContactNumberStyles {
    wrapperStyles?: InjectableCss;
    iconStyles?: IconProps;
    textStyle?: TypographyPresentationProps;
    mobileTextStyle?: TypographyPresentationProps;
    mobileIconStyles?: IconProps;
    hiddenContainerStyles?: HiddenProps;
}

export const contactNumberStyles: ContactNumberStyles = {
    wrapperStyles: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    iconStyles: {
        size: 18,
        css: css`
            margin-right: 5px;
        `,
    },
    textStyle: {
        forwardAs: "p",
        size: "14px",
        color: "text.main",
        weight: 800,
        lineHeight: "17px",
        css: css`
            letter-spacing: 0;
            margin-bottom: 0;
        `,
    },
    mobileTextStyle: {
        forwardAs: "p",
        size: "13px",
        color: "text.main",
        lineHeight: "16px",
        css: css`
            letter-spacing: 0.33px;
            margin-bottom: 0;
        `,
    },
    mobileIconStyles: {
        size: 12,
        css: css`
            margin-right: 10px;
        `,
    },
    hiddenContainerStyles: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
};

const styles = contactNumberStyles;

const ContactNumber: React.FC<Props> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.wrapperStyles}>
            <Hidden below="lg" {...styles.hiddenContainerStyles}>
                <Icon {...{ ...styles.iconStyles, src: Phone }} />
                <Typography {...styles.textStyle}>{fields.phoneNumber}</Typography>
            </Hidden>
            <Hidden above="md" {...styles.hiddenContainerStyles}>
                <Icon {...{ ...styles.mobileIconStyles, src: Phone }} />
                <Typography {...styles.mobileTextStyle}>{fields.phoneNumber}</Typography>
            </Hidden>
        </StyledWrapper>
    );
};

const definition: WidgetDefinition = {
    group: "Testing",
    fieldDefinitions: [
        {
            name: fields.phoneNumber,
            editorTemplate: "TextField",
            fieldType: "General",
            defaultValue: "",
            isRequired: true,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: ContactNumber,
    definition,
};

export default widgetModule;
